import React, { useContext, useEffect, useState } from 'react';
import { Modal, message, Form, Input, Select } from 'antd';
import { Context } from '../../../defaults';
import { isLoginExist, updateStudents } from '../../../actions';

export function StudentsModal({ modalProps, selectedValue, closeModal }) {
  const { actionType, visible, currentStudent, index } = modalProps;
  const [form] = Form.useForm();
  const { institutions, languagesType, classes } = selectedValue;
  const [exist, setExist] = useState(true);
  const { dictionary, language, setLoading } = useContext(Context);
  const modalTitle = actionType === 'save' ? 'Добавление студента' : 'Редактирование студента';
  const requiredMessage = 'Это поле является обязательным';



  const initialState = {
    lastName: '',
    firstName: '',
    middleName: '',
    institutionId: null,
    langId: null,
    phone: '',
    studyYear: '',
    country: '',
    city: '',
    region: '',
    classId: null,
    users: {
      login: '',
      email: '',
    },
  };

  useEffect(() => {
    if (actionType === 'edit') {
      form.setFieldsValue({ ...currentStudent, email: currentStudent.users.email });
    } else {
      form.setFieldsValue(initialState);
    }
  }, [actionType, currentStudent, form, initialState]);

  return (
    <Modal
      title={modalTitle}
      visible={visible}
      onOk={async () => {
        form.validateFields().then(values => {
          closeModal(values, index);
        });
      }}
      onCancel={() => closeModal()}
      okText="Сохранить"
      cancelText="Отменить"
      forceRender={true}
      width={600}>
      <Form
        form={form}
        labelCol={{ span: 7 }}
        wrapperCol={{ span: 18 }}
        layout="horizontal"
        initialValues={actionType === 'edit' ? currentStudent : initialState}>
        <Form.Item name="id" style={{ display: 'none' }}>
          <Input type={'hidden'} value={null} />
        </Form.Item>
        <Form.Item
          label={dictionary?.LastName[language]}
          name="lastName"
          rules={[{ required: true, message: requiredMessage }]}>
          <Input placeholder={dictionary?.LastName[language]} />
        </Form.Item>
        <Form.Item
          label={dictionary?.FirstName[language]}
          name="firstName"
          rules={[{ required: true, message: requiredMessage }]}>
          <Input placeholder={dictionary?.FirstName[language]} />
        </Form.Item>
        <Form.Item
          label={dictionary?.MiddleName[language]}
          name="middleName"
        >
          <Input placeholder={dictionary?.MiddleName[language]} />
        </Form.Item>
        <Form.Item
          label={dictionary?.UserLogin[language]}
          name="login"
          hasFeedback

          rules={[{ required: exist, message: requiredMessage }]}
        >
          <Input placeholder={dictionary?.UserLogin[language]}
            name='login'
            onChange={e => {
              isLoginExist(e.target.value).then(res => res.json()).then(res => res && message.warning(dictionary?.LoginExist[language]));
            }}
          />
        </Form.Item>
        <Form.Item
          name="institutionId"
          label={dictionary?.Institution[language]}
          rules={[{ required: true, message: requiredMessage }]}>
          <Select disabled placeholder={dictionary?.Institution[language]} allowClear={true}>
            {institutions &&
              institutions.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item
          label={dictionary?.Phone[language]}
          name="phone"
          rules={[{ required: true, message: requiredMessage }]}>
          <Input placeholder={dictionary?.Phone[language]} />
        </Form.Item>
        <Form.Item
          label={dictionary?.YearStudy[language]}
          name="studyYear"
          rules={[{ required: true, message: requiredMessage }]}>
          <Input placeholder={dictionary?.YearStudy[language]} />
        </Form.Item>
        <Form.Item
          label={dictionary?.StudyYear[language]}
          name="yearOfStudy"
          rules={[{ required: true, message: requiredMessage }]}>
          <Input placeholder={dictionary?.StudyYear[language]} />
        </Form.Item>
        <Form.Item
          name="email"
          label={dictionary?.Email[language]}
          rules={[{ required: true, message: requiredMessage }]}>
          <Input
            placeholder={dictionary?.Email[language]}
            name="email"
            onChange={(e) => {
              form.setFieldsValue({
                ...currentStudent,
                [e.target.name]: e.target.value,
                users: {
                  ...currentStudent.users,
                  [e.target.name]: e.target.value
                }
              });
            }}
          />
        </Form.Item>
        <Form.Item
          name="langId"
          label={dictionary?.Lang[language]}
          rules={[{ required: true, message: requiredMessage }]}>
          <Select placeholder={dictionary?.Lang[language]} allowClear={true}>
            {languagesType &&
              languagesType.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item
          label={dictionary?.Country[language]}
          name="country"
          rules={[{ required: true, message: requiredMessage }]}>
          <Input placeholder={dictionary?.Country[language]} />
        </Form.Item>
        <Form.Item
          label={dictionary?.City[language]}
          name="city"
          rules={[{ required: true, message: requiredMessage }]}>
          <Input placeholder={dictionary?.City[language]} />
        </Form.Item>
        <Form.Item
          label={dictionary?.Region[language]}
          name="region"
        >
          <Input placeholder={dictionary?.Region[language]} />
        </Form.Item>
        <Form.Item
          name="classId"
          label={dictionary?.Class[language]}
        >
          <Select placeholder={dictionary?.Class[language]} allowClear={true}>
            {classes &&
              classes.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.year} {el.letter}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
}
